import { PdpCinema } from "./pdp-cinema";

const pdpCinema = new PdpCinema();
pdpCinema.init();
